import React from 'react';
import PropTypes from 'prop-types';

import ConfirmationModal from 'widgets/Modal/ConfirmationModal';

const RemoveAllConfirm = ({
  removeAllConfirmOpened,
  onRemoveAllCancel,
  onRemoveAllConfirm,
}) => (removeAllConfirmOpened && (
  <ConfirmationModal
    title="Remove all items"
    onConfirm={onRemoveAllConfirm}
    onConfirmLabel="Remove"
    onCancel={onRemoveAllCancel}
    onCancelLabel="Cancel"
    className="tm-confirmRemoveAllPopup"
    mainViewScrollable
  >
    <p>
      Are you sure you want to empty this trolley?
    </p>
  </ConfirmationModal>
));

RemoveAllConfirm.propTypes = {
  removeAllConfirmOpened: PropTypes.bool,
  onRemoveAllCancel: PropTypes.func.isRequired,
  onRemoveAllConfirm: PropTypes.func.isRequired,
};

export default RemoveAllConfirm;
